module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagex"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "h2x"
  }, [_c('a', {
    attrs: {
      "id": "int"
    }
  }), _c('strong', [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "imagex1"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3x"
  }, [_c('a', {
    attrs: {
      "id": "ch1"
    }
  }), _c('strong', [_vm._v("§1. The first, most literal meaning of the word “logic”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We begin our treatment with a preliminary understanding of what the word “logic” means in its most direct and literal sense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The terms “logic,” “physics,” and “ethics” come from the Greek words "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-01.jpg"
    }
  }), _vm._v(" to which "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-02.jpg"
    }
  }), _vm._v(" is always to be added. "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-03.jpg"
    }
  }), _vm._v(" means roughly the same as the German term "), _c('em', [_vm._v("Wissenschaft")]), _vm._v(", “science.” "), _c('em', [_vm._v("Wissenschaft")]), _vm._v(", like the German word "), _c('em', [_vm._v("Landschaft")]), _vm._v(", refers to a region, and in this case a specific self-enclosed whole comprised of a manifold of grounded knowledge, that is, of cognitions drawn exclusively and judiciously from the very things the science seeks to know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-04.jpg"
    }
  }), _vm._v(" is the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-05.jpg"
    }
  }), _vm._v(" or "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-06.jpg"
    }
  }), _vm._v(" (the science of speaking), "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-07.jpg"
    }
  }), _vm._v(" is the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-08.jpg"
    }
  }), _vm._v(" and "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-09.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-10.jpg"
    }
  }), _vm._v(" is the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-11.jpg"
    }
  }), _c('a', {
    attrs: {
      "id": "rintfn1"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-12.jpg"
    }
  }), _vm._v(" is the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-13.jpg"
    }
  }), _vm._v(" that is, of “nature” understood in the broad sense of “world” or “cosmos.” For the Greeks, "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-14.jpg"
    }
  }), _vm._v(" takes in the entire realm of the world in the sense of what’s out there—the totality of stars, earth, plants, animals, humans, and gods. Today “physics” is one particular discipline within the general science of the world: it is the science of the material, inanimate things of the world. More specifically, in contrast to inorganic chemistry, for instance, it is the science of matter in terms of its absolute laws of motion. As a modern science of nature, physics discloses only certain contexts of the being of those beings that we call “the world.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-15.jpg"
    }
  }), _vm._v(" is the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0001-16.jpg"
    }
  }), _vm._v(" the science of the behavior or comportment of human beings toward other people and toward "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("themselves. It is the science of human being. Notice that we already mentioned human being when we spoke about "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0002-01.jpg"
    }
  }), _vm._v(" the science of the world. But [2] now the subject matter is human being—not as a thing that just shows up in the world, with nothing ontologically special about it that would set it off from plants and animals, something that is just “out there” like the flora and fauna. Rather, in the present case human beings are understood as beings that, so to speak, take their very own being in hand."), _c('a', {
    attrs: {
      "id": "rintfn2"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to the divisions established by Hellenistic scholasticism, these three "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0002-02.jpg"
    }
  }), _vm._v(" make up philosophy, the science of the whole of beings as such in their wholeness. “Physics” and “ethics” we can understand; but how is a “science of speaking” supposed to fit in with those two? Physics and ethics are disciplines that deal with two distinctive, universal realms of beings: the world and human beings. But how does a science that deals with so specific a matter as speaking get lined up with them? Why exactly should “speaking” become the subject of a universal (i.e., a philosophical) reflection? We will understand why once we have a natural and unbiased understanding of what is meant by "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0002-03.jpg"
    }
  }), _vm._v(" or “speech,” just as we do of those other two realms of beings: the world and human beings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We understand speaking not in the narrow and specialized sense of “giving a speech,” but simply as “speaking to each other” for the sake of interacting and working with each other. Talking to each other in this way means speaking about what’s going on, what could go on, and how to do things. It means discussing plans, projects, relationships, events, the ups and downs of life. To go back to what we said before: it means discussing how the world is and how human beings are. Speaking with each other is not something that goes on all the time, but speech itself—"), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0002-04.jpg"
    }
  }), _vm._v("—is always operative—whether we’re repeating what others have said, or telling stories, or even just silently speaking to ourselves or explaining things to ourselves or taking "), _c('em', [_vm._v("respons")]), _vm._v("ibility for ourselves. In this broad and natural sense, speech is a way that human beings behave, one that reveals to a natural, pre-scientific view what the difference is between human beings and other living things in the world. The specific being of humans is rendered conspicuous by speech. And [3] what is essential about speaking is that it is experienced as speaking "), _c('em', [_vm._v("to")]), _vm._v(" others "), _c('em', [_vm._v("about")]), _vm._v(" something.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not only is speaking to others and to oneself the behavior that makes human beings stand out as human; speaking is also the way that humans "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("direct and guide all their other kinds of behavior. It is in and through speaking that the modes and the objects of human action are disclosed, explained, and determined. Human behavior and human being first become conspicuous in and through speaking, and so in their early, pre-scientific characterization of human being, the Greeks defined human being as "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-01.jpg"
    }
  }), _vm._v("—the living being that can speak and that co-defines its being in and through such speaking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is clear, then, that speaking is not something incidental but an entirely distinctive and universal state of affairs, a form of behavior whereby humans give direction to their being and bring their world into discussion. Talking, therefore, is human being’s distinctive, universal, and fundamental way of comporting itself toward the world and toward itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-02.jpg"
    }
  }), _vm._v(" then, is what reveals an ontological connection between the other two universal regions we mentioned: human being ("), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-03.jpg"
    }
  }), _vm._v(") and world ("), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-04.jpg"
    }
  }), _vm._v("). So the regions that these three words designate provide us with an essential (if rough) classification of beings. Correspondingly the three disciplines of physics, ethics, and logic do not come together by chance. Rather, this threefold division and articulation is essential, and by means of it the three disciplines deal with the entirety of all beings. The basic topic of philosophy is the whole of beings; and these three disciples present us with a division of philosophical labor that we must hold to as entirely natural.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the development of the sciences, such divisions usually come later, after the original and basic investigations have first been carried out in each of the areas. The same goes for the names of these disciplines. Usually the names get set only when the divisions get established. [4]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("According to Sextus Empiricus,"), _c('a', {
    attrs: {
      "id": "rintfn3"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn3"
    }
  }, [_vm._v("3")]), _vm._v(", "), _c('a', {
    attrs: {
      "id": "rintfn4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn4"
    }
  }, [_vm._v("4")])]), _vm._v(" Xenocrates was supposedly the first to make this division explicit. It had been already current among the Stoics, whence it passed over into Hellenistic school philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-05.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-01.jpg"
    }
  }), _vm._v(" ("), _c('em', [_vm._v("Adversus mathematicos")]), _vm._v(" VII, 16)"), _c('a', {
    attrs: {
      "id": "rintfn5"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Those who have divided philosophy in a more complete way are those who say that one part of philosophy deals with "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-02.jpg"
    }
  }), _vm._v(" another part with "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-03.jpg"
    }
  }), _vm._v(" and a third with "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-04.jpg"
    }
  }), _vm._v(" Plato first pointed the way to this possible division of philosophy insofar as in his philosophy he treats of many things that deal with the world, many things that concern human being, and quite a lot about what pertains to speaking. But it was the disciples of Xenocrates and the students of Aristotle who most explicitly divided philosophy this way. The Stoics, too, still hold to this division."), _c('a', {
    attrs: {
      "id": "rintfn6"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kant still liked to invoke this threefold division, the way he does in the Preface to his "), _c('em', [_vm._v("Groundwork of the Metaphysics of Morals:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Ancient Greek philosophy was divided into three sciences: "), _c('em', [_vm._v("physics, ethics")]), _vm._v(", and "), _c('em', [_vm._v("logic")]), _vm._v(". This division is perfectly suitable to the nature of the subject, and there is no need to improve upon it except, perhaps, to add its principle, partly so as to ensure its completeness [5] and partly so as to be able to determine correctly the necessary subdivisions."), _c('a', {
    attrs: {
      "id": "rintfn7"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Note that Kant emphasizes the appropriateness of this division to the subject matter: i.e., it is a division that ultimately comes to the fore, more or less clearly, in every philosophical investigation. And when Kant says that one needs “only” to add the principle, we should bear in mind that the task of doing so continues to be one of philosophy’s fundamental concerns, one that has not been answered to this day and, when you get right down to it, hasn’t even been clearly posed either as a project or as a question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The preliminary clarification of the meaning of the word “logic” led to a preliminary orientation to a fundamental division of the philosophical disciplines. It also provided a first view of the regions of being to which this division and indeed the whole of philosophy are directed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("The division and the status attributed to logic as a discipline come about later than the issue they deal with—and the same goes for the emergence of the word "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-01.jpg"
    }
  }), _vm._v(" For example, we find "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-02.jpg"
    }
  }), _vm._v(" in Cicero,"), _c('a', {
    attrs: {
      "id": "rintfn8"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn8"
    }
  }, [_vm._v("8")])]), _vm._v(" in Alexander of Aphrodisias"), _c('a', {
    attrs: {
      "id": "rintfn9"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn9"
    }
  }, [_vm._v("9")])]), _vm._v(" (ca. 200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("C.E")]), _vm._v(".), in Galen."), _c('a', {
    attrs: {
      "id": "rintfn10"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn10"
    }
  }, [_vm._v("10")])]), _vm._v(" It does not yet show up in Aristotle, although the word "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-03.jpg"
    }
  }), _vm._v(" does. By clarifying the meaning of the word "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-04.jpg"
    }
  }), _vm._v(" we have already indicated the arena that is the topic of logic: speech in the broadest sense. We will now pursue that indication so that as we move toward a concept of the word, we may also get an initial concept of the subject matter.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex2"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common2.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "ch2"
    }
  }), _c('strong', [_vm._v("§2. A first indication of the concept of the subject matter of “logic”")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If we desire a more vital concept of “logic,” we have to ask a more penetrating question: What is the subject matter of the science of logic? In doing so, we leave aside any consideration of logic as one discipline among others—viz., the science of speaking and therefore of language—and focus instead on what it is "), _c('em', [_vm._v("about")]), _vm._v(". [6] That might seem to imply that the proper science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-05.jpg"
    }
  }), _vm._v(" would be linguistics or the study of grammar in the broad sense. In fact, even among the Greeks logic developed in connection with grammar understood as the study of language. More precisely, logic and grammar—the two disciplines that deal with "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-05.jpg"
    }
  }), _vm._v("—were not originally distinct. In fact, they were so "), _c('em', [_vm._v("in")]), _vm._v("distinct that the Greeks lacked a word for what we call “language.” That is, in the first stage of understanding "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-04.jpg"
    }
  }), _vm._v(" there was no distinction between "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-05.jpg"
    }
  }), _vm._v(" as the act of speaking and "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-05.jpg"
    }
  }), _vm._v(" as language. The word for “speaking” subsumed what we call “language.” On the other hand, [speaking as] making verbal sounds was the most direct way that “language” was experientially "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("accessible to the Greeks. That is why they first came to understand “language” with regard to the differences between the various forms of words and between the different possible ways words can be brought together [in a sentence]. But the Greeks likewise, and just as basically, understood that "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0006-01.jpg"
    }
  }), _vm._v(" consists in speaking "), _c('em', [_vm._v("about")]), _vm._v(" something, speaking "), _c('em', [_vm._v("of")]), _vm._v(" something. That is, they saw that the basic achievement of speech consists in showing or revealing "), _c('em', [_vm._v("what")]), _vm._v(" one is speaking about, "), _c('em', [_vm._v("what")]), _vm._v(" one is discussing. Indeed, making vocal sounds was quite secondary to that."), _c('a', {
    attrs: {
      "id": "rintfn11"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In such acts of revealing, whatever one is speaking about shows up, becomes perceivable, and, as something perceived, gets "), _c('em', [_vm._v("defined")]), _vm._v(" in and by the discussion about it. This revelatory defining of what is experienced and perceived is the very same thing that we generally call “thought” and “reflection.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In summary: in our primary, natural experience of how human beings live together with each other, we understand speech as the revealing of something by speaking about it, and as a thinking that determines and orders it. Language, speaking, thinking: they coincide as the human way of being. They are the way we reveal and illumine (both for ourselves and for others) the world and our own human existence ["), _c('em', [_vm._v("Dasein")]), _vm._v("], so that in this luminosity we gain sight: human insight into ourselves and an outlook on, and a practical insight into, the world. Logic as the science of speaking, studies speech in terms of what it properly is: the revealing of something. The subject matter of logic is "), _c('em', [_vm._v("speech")]), _vm._v(" viewed with regard to its basic meaning, namely, allowing the world, human existence, and things in general to be seen. [7]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact that existence has and understands and strives for this basic form of revealing implies that, for the most part, much of the world stands in need of “revelation,” of being un-covered and made known. In other words, much of the world and much of human existence is by and large not un-covered. So beings can be drawn out of their not-un-covered-ness, their hiddenness. They can be un-covered or un-hidden. This uncoveredness or unhiddenness of beings is what we call truth."), _c('a', {
    attrs: {
      "id": "rintfn12"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Logic investigates speaking—the thinking that defines things—inasmuch as speaking uncovers things. The topic of logic is speech, specifically with regard to truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In other words, to the degree that we clarify the meaning of truth, we will be in a position to properly understand speech, "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0006-01.jpg"
    }
  }), _vm._v(". The "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("basic topic of the science of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0009-01.jpg"
    }
  }), _vm._v(" is truth in the quite general sense of the questions, “What is truth in general?” or “What constitutes the structure and make-up of truth?” and “What possibilities and forms does truth have?” and finally, “What is the basis on which rests what we properly call truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our definition of logic as the science of truth could be misunderstood. One might object that "), _c('em', [_vm._v("every")]), _vm._v(" science deals with truth, that truth is what all scientific knowledge is after. Yes, except that there is a misleading ambiguity here in how the word truth is being used. In a strict sense, no individual science other than logic deals with "), _c('em', [_vm._v("truth")]), _vm._v(". The [natural] sciences, on the other hand, deal only and always with the true, i.e., "), _c('em', [_vm._v("what")]), _vm._v("-is-true; and they do so within the arena of the knowledge of nature. Or outside of the [natural] sciences, one inquires into what-is-true for human action, or about the true that faith gives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But logic does not ask about the what-is-true in just any sense. Rather, it inquires primarily and properly into the "), _c('em', [_vm._v("truth")]), _vm._v(" of [8] what-is-true. It asks: What makes this or that true thing "), _c('em', [_vm._v("be")]), _vm._v(" true in a given case? and what makes it be "), _c('em', [_vm._v("this")]), _vm._v(" true thing? The only way to make any grounded sense out of the truth of theoretical-scientific knowledge, practical reflection, or religious truth is to get to the foundation that lets us understand what truth means at all. Only from that foundation can we decide which kind of truth is most original, and whether the ideal of truth is to be found in theoretical-scientific truth or practical insight or religious faith. In other words, it is not easily decided which form of the true is primary and most basic. Even in today’s philosophy, this question has not yet been settled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of course the philosophical tradition and philosophical research have, from their inception, always been oriented to a certain kind of knowledge and truth, namely, theoretical cognition. The truth of the theoretical proposition, the statement, has become the privileged paradigm for the true as regards its truth. One specific form of truth became the ideal, and whenever one reflected on the meaning of practical or religious truth, that reflection was always carried out in a framework that kept theoretical-scientific knowledge strictly separate from practical knowledge, which was thought to be a more limited and less rigorous form of cognition. In modern philosophy, the ideal of theoretical truth carried the day in a hyperbolic form inasmuch as the ideal of truth was not just theoretical truth in general but the truth-character of a very specific kind of theoretical cognition: mathematical knowledge. Mathematical knowledge was seen as the proper and most rigorous kind of knowledge. This ideal was so dominant that even until recently one was still trying to assimilate the science of history to the ideal of mathematical knowledge. Even when [9] one does not expressly articulate this ideal and adhere to it as such, nonetheless, "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("thanks to the influence of modern philosophy, that ideal continues to have a strong impact on the question of the essence of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus, among the various meanings of the word truth, the real priority goes to the sense of truth that is oriented to propositional statements. In order to first get some (in fact, very extrinsic) clarity on this ambiguous word “truth,” let me mention some of its meanings by simply listing them at this point without going into the relevant explanations of what they mean.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the first place, truth is understood to be a feature of statements about things. Truth is thus a property of propositions, by virtue of which they express something just as it is.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Secondly, however, truth is understood not simply as a property of propositions and statements. We also call the statement itself a truth, as when we say: “ ‘Two plus two equals four’ is a truth,” or “There are many truths” (i.e., many [true] propositions and statements), or when we speak of eternal and temporal truths or of absolute and relative truths. In all these cases, truth is not just a property of propositions but is the propositions themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thirdly, truth means the same as "), _c('em', [_vm._v("knowledge")]), _vm._v(" of a truth, as when we say, “So-in-so cannot bear the truth.” That means that so-in-so resists knowledge of the truth, hides from it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fourthly, we also use the word truth to mean an aggregate of true propositions about a state of affairs. When we say, “We want to learn the truth about this or that event,” this refers to the collection of possible statements that must be made if we are to have access to the event just the way it happened, and, if we may say so, just the way it "), _c('em', [_vm._v("is")]), _vm._v(". [10]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifthly, truth also has the sense of “the true,” where “the true” means the real, just as it is. When we speak of “true gold,” we mean real, genuine gold. The same goes for speaking of the “true God.” In these cases, our statements are not focused on the mere "), _c('em', [_vm._v("things")]), _vm._v(" we are speaking about, so that the statement would be true by simply expressing how things are out there. It’s quite the reverse. In these cases a thing is properly called “true” only when it is in such a way as to correspond to its “idea.” When something "), _c('em', [_vm._v("is")]), _vm._v(" what it "), _c('em', [_vm._v("should be")]), _vm._v(" according to the idea of that thing, only then can we say, for example, it is “true gold” and not “sham gold,” mere fool’s gold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pulling these different senses of truth together, we see a formal structure that recurs in all of them. In the first four cases, the statement is true when it speaks of the thing "), _c('em', [_vm._v("just as")]), _vm._v(" the thing is. But in the fifth case—“true” in the sense of “real”—it is the reverse. The thing is true when it is "), _c('em', [_vm._v("just as")]), _vm._v(" it is according to its idea, the essence of the thing as apprehended by reason ("), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0008-01.jpg"
    }
  }), _vm._v(" or even "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0008-02.jpg"
    }
  }), _vm._v("). In this latter case, "), _c('em', [_vm._v("genuine")]), _vm._v(" gold is what corresponds to the "), _c('em', [_vm._v("idea")]), _vm._v(" of gold. In both cases, however, truth has the formal structure of "), _c('em', [_vm._v("just-as")]), _vm._v(" or "), _c('em', [_vm._v("as-so")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("The name we give this whole formal structure of just-as is “correspondence” or in Latin, "), _c('em', [_vm._v("adaequatio")]), _vm._v(". For now let us be satisfied with this preliminary determination of the formal structure of the true. Later we will have to deal more deeply with the question of this remarkable structure of just-as: what its source is, how it is possible as such—in a word, the "), _c('em', [_vm._v("ground")]), _vm._v(" on which truth as such rests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From what we have said, it is clear that from the very beginning, philosophical reflection took "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0009-01.jpg"
    }
  }), _vm._v(" (speech) primarily as expressed speech; and within that, it took "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0009-01.jpg"
    }
  }), _vm._v(" in what appeared to be its simplest manifestation: the statement, where “uttering” and speaking take the linguistic form of sentences in the form of statements such as, “The sky is blue.” [11]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The more this form of speech obviously presents the most basic form of theoretical-scientific knowledge, the more it imposes itself on logical reflection. Any definitive study formulates its conclusions in propositions, especially insofar as they are statements about the world. Formulated as simple “propositions,” statements about the world that reflect on and determine the world, came to be the simplest, most general, and likewise the most basic form of speech. Even the determination of truth now gets oriented, primarily and in principle, to this kind of speech, the propositional statement. The act of un-covering things in statements is what is true, and so the truth of theoretical-scientific knowledge has become the basic, original form of truth as such. The truth of [propositional] knowledge attains a universal primacy. To the degree that any other forms of truth enter the field of reflection, they are measured against the standard of the truth of [propositional] cognition and are understood as derived from it, as modifications of it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is far from evident, however, that theoretical-cognitive truth, or even the truth of statements, is the basic form of truth in general. Philosophy’s first determination of truth, and the tradition of logic that follows from it, are oriented in terms of this idea of truth; but so too is linguistic usage, which is bound up with them in a certain way. So in its decisive origins logic was already oriented toward this truth of theoretical apprehension and cognitive determination. From that point until now, this orientation of logic and philosophy has remained fundamentally in place.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We will see that this primacy of theoretical truth within logical investigation is not accidental. But we must also make it clear that understanding the project of logic and questioning it more radically requires that we go back to this naïve beginning of logic and shake it to its roots. In other words, it is far from settled which kind of “true”—the theoretical or the practical—is original and authentic. Instead, the question about [12] the originally and authentically “true”—i.e., the question of the primary "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("being of truth—is logic’s most basic concern, but only when logic has the will to be a searching, scientific logic—a logic that philosophizes.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common2.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "ch3"
    }
  }), _c('strong', [_vm._v("§3. A philosophizing logic and traditional scholastic logic")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But if logic is, by definition, a discipline within philosophy, is there really any kind of logic other than philosophical logic? There certainly is. The kind of logic that is and was commonly taught in the universities of today and of yesteryear is a logic that has given up on any kind of philosophy, that is, any kind of serious questioning and investigation. This so-called “scholastic logic” is not philosophy, and it is not any one of the particular sciences. It is a form of sloth, kept alive by custom and by off-the-record academic arrangements and desires. It is also a fraud.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scholastic logic is a form of sloth tailor-made for instructors. All they have to do, year after year, is parrot the same old stock of unchanging, shopworn propositions, formulas, rules, and definitions. Variations in how these logic courses are taught is confined to how the teacher packages it, how thorough he is, and what kind of examples he chooses. In this kind of “logic,” the logician never runs a risk, never has to put up or shut up—which is the price that you have to pay to do real philosophy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a fraud perpetrated on the students. They are trapped for a whole semester studying stuff of utterly dubious value. It would be easier and more expeditious for them—not to mention quicker and cheaper—to just read the stuff on their own in any logic manual.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This kind of scholastic logic can certainly appeal to a long tradition of teaching that reaches back through the Middle Ages [13] to the time when logic was originally established as a discipline (see above). But even the most ancient of traditions cannot claim its own legitimacy when it began as a result of a decline, or better, began "), _c('em', [_vm._v("as")]), _vm._v(" a decline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Traditional scholastic logic comes from a period when philosophy had already lost its character as a productive force. The fact that later, creative philosophers have since taken this logic under their wings changes nothing basic. Traditional scholastic logic retains the content (but trivialized, uprooted, and mummified) of an original philosophical questioning that was alive in Plato and Aristotle but got completely stifled and rigidified by the schools.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The endless retailing of this over-the-counter stock of scholastic logic is an outrage to real philosophizing. It is beneath the dignity of the university as a place of questioning and searching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our decision for a philosophizing logic, our repudiation of the "), _c('em', [_vm._v("collegium logicum")]), _vm._v(" in its traditional form, is neither some rash rejection of the tradition, nor is it a supercilious disdain for solid learning, for getting an academic position, and even less so for the university. Quite "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("the contrary, we should prepare ourselves to retrieve the genuine tradition from out of the ruins of the sham, to really appropriate the productive and living elements that lie under the rubble of scholastic logic. But we will engage in direct confrontation with that earlier philosophizing logic only if we ourselves do logic in a philosophizing manner. The result will be to see that Aristotle’s logic, for example—or more precisely, his work on that area of research—is quite different from the scholastic logic that likes to appeal to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In his lecture course "), _c('em', [_vm._v("Logic")]), _vm._v(", Kant says:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("Contemporary logic is a descendant of "), _c('em', [_vm._v("Aristotle’s Analytic")]), _vm._v(". This philosopher can be regarded as the father of logic. [14] He expounded it as an organon and divided it into "), _c('em', [_vm._v("analytic")]), _vm._v(" and "), _c('em', [_vm._v("dialectic")]), _vm._v(". His manner of teaching is very scholastic and has to do with the development of the most universal concepts, which lie at the basis of logic, but no one has any use for it because almost everything amounts to mere subtleties, except that one [has] drawn from this the names for various acts of the understanding. From Aristotle’s time on, logic has not gained much in "), _c('em', [_vm._v("content")]), _vm._v(", by the way, nor can it by its nature do so.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Compare the Preface to the second edition of his "), _c('em', [_vm._v("Critique of Pure Reason:")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("We can see that from the earliest times "), _c('em', [_vm._v("logic")]), _vm._v(" has traveled this secure course from the fact that since the time of Aristotle it has not had to go a single step backwards unless we count the abolishing of a few unnecessary subtleties or the more distinct determination of its presentations. These improvements pertain more to the elegance of that science than to its security. (B viii)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Kant wrote or spoke those lines from the "), _c('em', [_vm._v("Logic")]), _vm._v(", he knew nothing of Hegel and of the logic that he was already composing, which would eventually make Hegel what he became and will ever remain: the only-begotten and co-equal son of the Father of Logic. In philosophical terms this means that the philosophical logic founded by Aristotle and completed by Hegel will not be advanced by any further son-ship and uncle-hood. In order to advance philosophically, it needs a new lineage. When that will come about, no one knows. We of today are certainly not it. But the positive contribution to be made by those few who now understand what is at stake will consist in a work of transition: bringing to life again the productivity of the past and taking it into a future that we dimly see but are not yet up to. That’s why it’s all the more urgent that we carry through with questioning, and free ourselves from the chains of rigidity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But is it in fact true that the cultivation of traditional scholastic logic really promotes only a cult of tradition and a dependence on custom? "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Wasn’t there some essential usefulness to it? I don’t want to dodge the major reason people give for maintaining and encouraging this logic. People say and think and believe, in an agreement that goes without saying, that [15] studying scholastic logic teaches you how to think and helps you reach a higher level of learning and a greater exactitude in thinking. So it’s something we should strive for right from the beginning of our scientific studies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a basic misunderstanding. Thinking, and especially scientific thinking, can be learned only by getting involved with the subject matter. It would be the greatest mistake to think that a "), _c('em', [_vm._v("collegium logicum")]), _vm._v(" could make up for a lack of methodical, conceptual hard work in a science or the communication of that work through teaching.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The objectivity of scientific questioning and the precision of conceptual definition grow out of an increasing familiarity with the area of a given science’s subject matter. What is more, such familiarity is possible in a positive sense only when an individual, at the core of his or her human existence, has gained a basic relationship to this subject matter, whether by an inner choice and decisive struggle or by an unexplainable inner calling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This holds not only for theoretical scientific thinking but also for the field of practical undertakings and political power, where scholastic logic has nothing to say. It even misleads when it turns into mere drill and blind learning, and especially when it becomes a hair-splitting and empty form of arguing, cut off from the subject matter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Conversely, understanding what scholastic logic has to offer presupposes a very comprehensive and well-developed philosophical thinking, especially when this logic is simply presumed, apparently naïvely, instead of going back into the vital origins of its settled formulae and theorems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s a fool’s errand to expect that traditional logic will teach us how to think. But on the other hand we certainly can clarify scientific work and academic study—in a word, the whole form of existence that they encompass—but only by way of a philosophizing [16] logic, that is to say, only through a living and effective connection with the concrete practice of a given science."), _c('a', {
    attrs: {
      "id": "rintfn13"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Transparency in one’s scientific comportment and one’s scientific life means having a relationship of understanding with the whole of a science and its basic components and their interconnections. For now let us simply note those components in a list:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("1. The subject matter of the science.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("2. The world: generally speaking, the things from out of which the subject matter is selected.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("3. The basic way in which the selection is made.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("4. The relation to the world in which the science’s subject matter is rooted.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("5. The viewpoint that guides one’s inquiry into the subject matter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("6. The kind of apodictic insight, expressible in propositions, that is to be attained.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("7. The relevant ways of forming concepts. (There are structural differences between the "), _c('em', [_vm._v("exact")]), _vm._v(" concepts of physics, the "), _c('em', [_vm._v("morphological")]), _vm._v(" concepts of botany, and the "), _c('em', [_vm._v("historical")]), _vm._v(" concepts of philology.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("8. The manner in which proofs are communicated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumber"
  }, [_vm._v("9. The sense of the validity of the binding “propositions” gained in the particular sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("All these components get modified according to the different sciences and groups of sciences.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clarity in research is not attained simply by being aware that these basic components are present in a science. It is had, rather, when these elements spring to life, so to speak, in concrete occasions of our scientific work in such a way that the path of our work of research and assimilation is suddenly lit up and leads us forward or becomes problematic and unsure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A science does not develop because some scholar discovers something new in a specific situation. Rather, in each case the sudden jolt by which any given science moves forward [17] consists of a revision of basic concepts. From then on, a science develops by taking the heretofore available stock of propositions and concepts and putting them on a new foundation. Einstein’s revolution in contemporary physics was carried out in this way. It’s not the case that he began to philosophize about basic concepts of physics. Rather, in working on specific problems he looked into the basic concepts contained in those problems and saw that if he was to remain at all committed to the goal of physics, a revision of those concepts was needed. It is hard to see it so clearly today, but an analogous revolution was Dilthey’s achievement in the science of history, namely, the shift of historical research to what we now call the history of human spirit. Scholars up to the present, at least in their concrete work, still have not understood this achievement—which shows that a paradigm shift within this field is more difficult to carry out, whereas the siren song of dilettantism is easier to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Understanding the nine points listed above is the source of transparency in the life of science. Those points are not just thrown together. They are understood from out of a primary pre-understanding "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("of the current whole of the sciences. The basic structure of that whole is the possible “truth” within which any research activity operates. In other words, the constitutive elements themselves are only necessary structural moments of theoretical truth. Thus they can be understood and are to be appropriated from out of the pre-understanding of theoretical truth and ultimately of truth in general. This means that clarity in scientific research is possible only by way of a philosophizing logic."), _c('a', {
    attrs: {
      "id": "rintfn14"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn14"
    }
  }, [_vm._v("14")])]), _vm._v(" Scholastic logic never delivers on its claim to teach us how to think. On the other hand, what is basically meant by that claim—viz., of the transparency of scientific research—can be fulfilled only by a philosophizing logic. To be sure, [18] that last sentence is spoken from the viewpoint of the ideal. Trying to promise that the following “logic” will concretely achieve anything like that would be not only presumptuous but also a misunderstanding of philosophy. Really very little can be said about philosophy. Instead of giving an extended explanation of its essence, I will merely allude to one thing that pertains to philosophy: the fact that the philosopher reserves to himself the possibility of making mistakes. The courage to err does not mean just the courage to put up with one’s errors. It means much more: the courage to admit one’s errors. It is courage for the inner release of one’s own self in order to listen and learn, the courage for positive discussion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Not only in the realm of scientific research but in every possible kind of existence, individuals are only what they are able—and have the courage—to demand of themselves")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The rejection of traditional scholastic logic can be easily combined with true esteem for the tradition. To esteem the tradition does not mean remaining blindly bound to what-has-been as such—the past as such—or stubbornly refusing to go beyond the handed-down tradition "), _c('em', [_vm._v("as")]), _vm._v(" handed down. True esteem for the tradition is grounded in the historicity of human existence itself, that is, in the original fidelity of human existence to itself. Fidelity means getting close to and holding on to that which is seized and won by struggle and that holds our existence in suspense.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within the circle of tasks reserved to philosophizing logic, the central concern—which will get clearer later on—is the question, “What is truth?” We really have to ask this question. Philosophizing logic consists in the searching passage through this question. It is the only way we gain the possibility of understanding "), _c('em', [_vm._v("from the roots up")]), _vm._v(" former attempts to ask this question about truth. Only from those roots can we understand the process whereby this question dried up and died out in scholastic teaching. Consequently, the aforementioned rejection of traditional scholastic logic is nothing [19] other than the movement toward "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("the philosophical appropriation of the genuine philosophical content that is locked up inside that logic.")]), _vm._v(" "), _c('p', {
    staticClass: "imagex2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common2.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "ch4"
    }
  }), _c('strong', [_vm._v("§4. The possibility and the being of truth in general. Skepticism")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When we assign philosophizing logic the fundamental task of really asking the question, “What is truth?” it might seem that we are giving only a preliminary formulation of the problem and that logic is not yet being put on the genuine road to originality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The question to be asked before all others has to be: Does it make any sense to ask about truth? Is not the very idea of truth an illusion? “Is” there truth at all?—in other words, is there something whereby things are given just as they are? And we could even ask the further question: Are there things at all? And then we would end up with a whole series of questions that the ancient skeptics have already asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Compare Gorgias, as described by Sextus Empiricus:")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0015-01.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0015-02.jpg"
    }
  }), _vm._v(" ("), _c('em', [_vm._v("Adversus mathematicos")]), _vm._v(" VII, 65)")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("In his book "), _c('em', [_vm._v("On Non-being")]), _vm._v(" or "), _c('em', [_vm._v("On Nature")]), _vm._v(", Gorgias discusses three major theses in succession: first, that there is nothing; second, that if there is something, it cannot be apprehended by human beings; and third, that even if it can be grasped, it still cannot be expressed and made intelligible to others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Before")]), _vm._v(" the question of "), _c('em', [_vm._v("what")]), _vm._v(" truth is, there comes the question of "), _c('em', [_vm._v("whether")]), _vm._v(" it is at all. Before sketching out what it is, we have to prove "), _c('em', [_vm._v("that")]), _vm._v(" it is. Against this position, we may propose this formal argument: focusing on and discussing the question whether there is truth at all implies that we already have some understanding of truth. We [20] must somehow know what a thing is if we are to decide its being or non-being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, even if it should turn out that there is no truth and that it cannot be understood and communicated, we still have to clarify what we mean by “truth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In fact, precisely because this thesis is supposed to be held as a fundamental proposition, the content of the thesis as well as the meaning of “truth” must have the transparency of a principle. But that implies "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("that the explanation of what truth is comes before the question of whether it can be apprehended and communicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But with regard to the very question of whether there is truth, we would choose to say that the obvious answer is “yes.” And then when we explain what truth is, we already presuppose that it is possible to make true statements about the essence of truth. The intention to discuss something presupposes the prospect and intention of clarifying it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Basically, then, the question of whether there is any truth at all is already answered by the fact that we are discussing it. And (so one says) we answer the question [“Is there any truth?”] in the affirmative even when we deny that there is truth, insofar as the denial claims to be a true statement about the non-existence of truth. The denial of the existence of truth affirms the truth of the denial, and therefore the existence of truth. The positing of such a denial, which we usually call skepticism, contradicts itself and therefore is impossible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So the outcome is: (a) The question that seems to be primary—whether there is truth at all—is not at all the first question. (b) In fact that question is not even the topic for a meaningful discussion insofar as it always presupposes the possibility of truth. At best, we can clarify in an explicit way the necessity of this presupposition. We might say that this task is the prolegomenon for any and all logic. [21]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are no further grounds for asking an intelligent question that could get behind this basic presupposition that there is truth after all. Reflection has here reached a limit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At this limit of reflection and discussion, the assurance that truth exists seems almost to be self-guaranteed. The possibility that skepticism could endanger the existence of truth is neutralized as soon as we realize that the skeptic refutes himself and cancels himself out, puts himself out of business as an alternative position.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But a refutation of skepticism is a refutation of every kind of relativism, every statement that there is no absolutely valid truth. For even the statement that there is only relative truth—if it is made in earnest—is self-contradictory. The statement says that it is absolutely the case that there is only relative truth. So there is at least "), _c('em', [_vm._v("one")]), _vm._v(" absolute truth. Consequently, the thesis itself is undermined, the position is untenable. So the situation is this: The question “What is truth?” is the basic question (1) because even the question of whether there is truth already presupposes the concept of truth, and (2) because likewise this question answers itself even before it is asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the last reason we gave is ultimately not sustainable, because precisely when we formulate the question of a philosophizing logic, we have to doubt whether the problem of skepticism can be dismissed as cheaply and easily as that; whether it makes any sense to refute "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _vm._v("skepticism; and whether skepticism can be captured in such a simple formula.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe skepticism is only a construction of its opponents who want to refute it in order to get a sense of security by refuting it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On closer inspection, we see that both this skepticism and the refutation of it presuppose a very specific concept of truth; that this concept is not at all the original one; and therefore that this refutation is [22] not a radical consideration at all but only the semblance of a self-evident presupposition, only the mirage of a limit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To be sure, the question “What is truth?” is the basic question—not, however, because it maintains that the problem of skepticism is already solved from the beginning. Rather, the problem of skepticism belongs in an essential way among the set of questions about the condition of the possibility of truth at all. But then there is a multitude of things to be discussed."), _c('a', {
    attrs: {
      "id": "rintfn15"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1. One needs to demonstrate that this supposedly fundamental consideration—the refutation of skepticism—still does not and cannot deal with the real, genuine presuppositions. That is because both sides—the skeptic and his refuter—presume that the truth, whose being and non-being they are debating, is "), _c('em', [_vm._v("propositional")]), _vm._v(" truth. This is especially clear in the one who would refute skepticism. To confound the skeptic, he appeals to the principle of non-contradiction: there can be no truth where there is contradiction, especially the self-contradiction we find in the assertion of skepticism. But contra"), _c('em', [_vm._v("diction")]), _vm._v(" and non-contra"), _c('em', [_vm._v("diction")]), _vm._v(" make sense as a criterion only where this criterion is applied to “"), _c('em', [_vm._v("diction")]), _vm._v(",” to speaking back and forth, i.e., to "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0017-01.jpg"
    }
  }), _vm._v(" a statement in the sense of a proposition. Ultimately, the refutation is centered on the thesis that in every true statement, so one says, the existence of truth is co-affirmed. There the refutation rests its case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It doesn’t even go so far as at least to show "), _c('em', [_vm._v("why")]), _vm._v(" (i.e., on what basis) it must be the case that the existence of truth is co-affirmed in every true statement. It presumes the matter is self-evident. It never asks, much less answers, that question, and therefore this supposedly fundamental consideration that wants to get to ultimate presuppositions is not fundamental at all. [23]")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("2. This supposedly fundamental consideration makes an appeal to the principle of contradiction as a criterion, and therefore an appeal to fundamental proof and provability. But what does proof mean? What is the origin of the claim to prove? What is the condition of the possibility of proof at all? What is the origin of the “why?”—not to mention "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("the “therefore”! And where does the necessity of unprovability find its basis?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("3. The principle of contradiction and the principle of identity are presupposed to be self-evident, with no questions asked about whether they are actually ultimate. I don’t mean to say these principles should be reducible to simpler ones. However, we should at least entertain the question of whether or not the “proposition” of contra"), _c('em', [_vm._v("diction")]), _vm._v(" is simply a specific and determinate “expression” for an original basic relation that does not primarily lie in the dimension of statements and propositions. Hence, appealing to this proposition—even apart from the fact that the appeal leads us into the dimension of the theoretical statement—does not as such touch on the real presuppositions of truth in general."), _c('a', {
    attrs: {
      "id": "rintfn16"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("4. In both the argumentation for and the refutation of skepticism, the issue is whether or not there is truth, whether or not it exists. But what goes unasked in all this is what the being of truth means, what the “there is . . .” refers to. There are automobiles, Negroes, Abelian functions, Bach’s fugues. “Are there” truths, too? Or if not, what then?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("5. This delineation of skepticism and of the refutation of skepticism claims to deal with the ultimate presuppositions of all philosophy—but without asking about the meaning and necessity and possibility of presupposing as such. After all, where is there such a thing as presupposing? And why must there be? What is the basis for the necessity of making "), _c('em', [_vm._v("pre")]), _vm._v("-suppositions? The more noise one makes about “the self-evident,” the more puzzles there are to solve. But to philosophize means to be entirely and constantly [24] troubled by and immediately sensitive to the complete enigma of things that common sense considers self-evident and unquestionable. Of course such philosophizing requires that we hunt down and look into these “immediately self-evident” things, and for that we need the right direction and the crucial light for finding our way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This list of questions should make it clear that the supposedly basic reflection [on skepticism] is only a semblance of that. Later on, when we again take up and investigate these questions in their proper place, we will have to show how they are intimately connected with the question, “What is truth?” This will show us that the question about the essence of truth leads to a dimension that will remain completely closed to those who orient the basic concept of truth to truth as the validity of propositions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Far from being a foundation-laying prolegomenon to philosophizing logic, the above discussion of skepticism and relativism is only an "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("indication of the fact that the basic question of logic has not yet reached the dimension of philosophical questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nowadays, however, that very discussion serves as a preparation for laying the foundations of logic. We find prolegomena to pure (philosophical) logic not in the realm of scholastic logic, but precisely in the one place where inquiry in logic is still alive in our day: in Edmund Husserl’s "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(", published in 1900–1901, which, although little enough understood, was the first book to shake up present-day logic again and to advance its productive possibilities."), _c('a', {
    attrs: {
      "id": "rintfn17"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn17"
    }
  }, [_vm._v("17")])]), _vm._v(" The first volume of these "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" is subtitled, “Prolegomena to Pure Logic,” which means it deals with what first has to be clarified prior to any and all logic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first volume is a principled refutation of psychologism as a form of skepticism and of relativism, followed by the positive presentation of the idea of pure logic. If the questions we posed [25] about skepticism and especially about its refutation are correct, then it follows that even contemporary philosophical logic has not gotten down to the real foundations. In fact its questions have not even moved in that direction. Instead, it is constructed on something it presumes to be self-evident: truth as the truth of propositions, truth as the validity of statements."), _c('a', {
    attrs: {
      "id": "rintfn18"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn18"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given what we said about transparency and about skepticism, it is clear that the question “What is truth?” will force us into some fundamental reflections.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, because this course is also supposed to be of an introductory nature, it does not start right off with a treatment of the question “What is truth?” Instead, in "), _c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part I")]), _vm._v(" of the course we want to get acquainted with the crucial historical origins of the problem of truth in the Western philosophy in which we ourselves stand. In so doing, we will rely on the authentic documents of the origin of philosophical logic, and we will glean, as it were, a "), _c('em', [_vm._v("collegium logicum")]), _vm._v(" from Aristotle "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("himself, the founder of such logic, but one freed of the incrustations and rigidifications of a bad tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That should give us a preparatory basis for working out, in "), _c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part II")]), _vm._v(" of the course, the question that radicalizes everything: “What is truth?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parts I")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")]), _vm._v(" are preceded by a prolegomenon in which we focus on the formulation of the questions that Husserl’s "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" and phenomenology have introduced into contemporary logic. After that, we will steer the question back into the decisive beginnings. [26]")]), _vm._v(" "), _c('p', {
    staticClass: "imagex2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/common2.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "h3c"
  }, [_c('a', {
    attrs: {
      "id": "ch5"
    }
  }), _c('strong', [_vm._v("§5. Outline of the course.")]), _c('a', {
    attrs: {
      "id": "rintfn19"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn19"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('strong', [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What we said above indicates the basic plan of the course:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Prolegomenon. The current situation of philosophical logic. (Psychologism and the question of truth.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part I")]), _vm._v(". The problem of truth in the decisive origin of philosophical logic, and the seedbed of traditional logic (focused on Aristotle).")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("1. The theory of statement, proposition, judgment. (This in connection with Aristotle’s treatise—which is more like a sketch of this problem—"), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0020-05.jpg"
    }
  }), _vm._v(" "), _c('em', [_vm._v("De interpretatione, On Interpretation")]), _vm._v(", the second in the collection of Aristotle’s so-called “logical writings.” Later I’ll say something about how we will carry this out.)")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("a. The basic structure of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0009-01.jpg"
    }
  }), _vm._v(" and the phenomenon of meaning and sense: what do they both mean?")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("b. The structure and the meaning of the “copula.” (In the statement “This board is black,” the “is” is designated as the copula. This particular “is” will concern us in great detail.)")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("c. Negating, negation, the “not” and its origin.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("d. The so-called principles of identity and of contradiction.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("2. The doctrines of")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("a. the definition or "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0020-01.jpg"
    }
  }), _vm._v(" which is a specific kind of "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0020-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("b. essence, in Greek, the "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0020-03.jpg"
    }
  }), _vm._v(" “whatness”: how and why we ask about the “what,” whatness—thatness. (Our treatment will follow another Aristotelian text, "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0020-04.jpg"
    }
  }), _vm._v(" ("), _c('em', [_vm._v("Posterior Analytics")]), _vm._v(" II).")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumbera"
  }, [_vm._v("c. “proof” (the “why”)—being—“the "), _c('em', [_vm._v("a priori")]), _vm._v("”—the problem of “presupposition.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("These questions make up "), _c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part I")]), _vm._v(", and by answering them we get an understanding of the ground from which ancient logic sprang and of what parts of it were treated in scholastic logic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part II")]), _vm._v(". The radicalized question: What is truth?")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("1. The foundations of truth in general.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("2. The authentic and original form of truth.")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("3. The possibilities of truth that are grounded in the above—the inauthentic and the non-original essence of truth."), _c('a', {
    attrs: {
      "id": "rintfn20"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn20"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_vm._v("4. Philosophical truth and scientific truth. [27]")]), _vm._v(" "), _c('p', {
    staticClass: "indentt"
  }, [_vm._v("Aristotle lies at the basis of our treatment in "), _c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part I")]), _vm._v(". Our interpretation will stick close to the texts, but it is not meant to go into them in great detail. For now the point is simply to come to understand the issue. Therefore, I will give a direct translation of the passages we are to deal with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most important of the works on logic going back to the mid-nineteenth century are:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("1. John Stuart Mill, "), _c('em', [_vm._v("System of Logic, Ratiocinative and Inductive: Being a Connected View of the Principles of Evidence and the Methods of Scientific Investigation")]), _vm._v(", 1843."), _c('a', {
    attrs: {
      "id": "rintfn21"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("Mill’s "), _c('em', [_vm._v("Logic")]), _vm._v(" had a very strong influence on Germany in the nineteenth century, but chiefly because of the opposition it provoked. It especially had an impact on Dilthey, who vigorously opposed what book 6 of this logic had to say about the humanities. Dilthey set his own position of the theory of the humanities against it. That is, in keeping with the entire orientation of his philosophy, Mill took it upon himself to interpret in a certain sense the humanities as a kind "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("of natural science. This logic also influenced Husserl’s teacher, Brentano. Even Husserl himself learned a good deal, both positively and negatively, from Mill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("2. Christoph Sigwart, "), _c('em', [_vm._v("Logik")]), _vm._v(", 2 volumes, 1873ff."), _c('a', {
    attrs: {
      "id": "rintfn22"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn22"
    }
  }, [_vm._v("22")])]), _vm._v(" A vast and important work on logic, recently published in its fifth edition edited by Hans Meier.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("In the traditional fashion, the first volume treats the theory of judgment, concept, and conclusion. The second volume treats the theory of method. Sigwart takes it upon himself to bring logic into close connection with the project of the sciences. In the second volume he specifically pursues an orientation to the philosophy of science. This logic has had its greatest influence on one of the contemporary schools of philosophy: the so-called value philosophy of Windelband and Rickert.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("3. Hermann Lotze’s "), _c('em', [_vm._v("Logic")]), _vm._v(", published in 1874 as "), _c('span', {
    attrs: {
      "href": "#/xhtml/part1#part1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("part 1")]), _vm._v(" of his "), _c('em', [_vm._v("System of Philosophy")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "rintfn23"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn23"
    }
  }, [_vm._v("23")])]), _vm._v(" It is equally as important as, and maybe even more essential and relevant than, Sigwart.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("It is in three books: “Of Thought,” “Of Investigation,” and “Of Knowledge.” Philosophically speaking, the most important book is the third. It has exercised a strong influence on the modern logic that is usually called the logic of [28] validity, or validity logic, or value logic. It has had an influence on Windelband and Rickert, but likewise, in some essential elements, on Husserl. That is especially so as regards the peculiar interpretation of the Platonic idea in book 3 of the "), _c('em', [_vm._v("Logic")]), _vm._v(", where Lotze tries to show that the Platonic idea is not a sensory thing but rather (to use his term) “has validity.” Already in 1843, when he was a young teacher, he had written a logic that was a livelier and, in my opinion, a philosophically more acute work."), _c('a', {
    attrs: {
      "id": "rintfn24"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn24"
    }
  }, [_vm._v("24")])]), _vm._v(" The large logic has recently been re-edited by Georg Misch "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("in the series Philosophische Bibliothek, published by Felix Meiner Verlag."), _c('a', {
    attrs: {
      "id": "rintfn25"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn25"
    }
  }, [_vm._v("25")])]), _vm._v(" Misch has written a valuable introduction to this logic, and within certain limits it is quite good on Lotze and on the whole development of logic.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("4. Wilhelm Schuppe, "), _c('em', [_vm._v("Erkenntnistheoretische Logik")]), _vm._v(", 1878.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("Lastly a work that is mostly forgotten but that nonetheless is at a high philosophical level, Schuppe’s so-called “epistemological” logic."), _c('a', {
    attrs: {
      "id": "rintfn26"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn26"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Among the most recent works, I would mention:")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("5. Alexander Pfänder’s "), _c('em', [_vm._v("Logik")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "rintfn27"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn27"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("This logic is influenced in an essential way by Husserl. It is elaborated phenomenologically, but in such a way that holds to the framework of traditional logic. It is, if I may put it this way, a traditional logic, phenomenologically purified. Very lucid, clearly written, and excellent for orienting the beginner. Published in 1920"), _c('a', {
    attrs: {
      "id": "rintfn28"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn28"
    }
  }, [_vm._v("28")])]), _vm._v(" both as a separate book and in the fourth volume of the "), _c('em', [_vm._v("Jahrbuch für Philosophie und phänomenologische Forschung")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "rintfn29"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/star.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("6. Heinrich Rickert.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("Heinrich Rickert has been influenced in an essential way by "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(", and he first revealed the influence, reluctantly, in his article “Zwei Wege der Erkenntnistheorie” [Two Paths of Epistemology], "), _c('em', [_vm._v("Kantstudien")]), _vm._v(" XI (1909), which became important for his further development. Whatever Rickert has to offer that is new with regard to his earlier position, he essentially owes to Husserl’s investigations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("7. Emil Lask.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("Within this same school, Husserl has strongly influenced Lask—Rickert’s student, who was killed in Galicia in 1915. In 1911, Lask "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("published his "), _c('em', [_vm._v("Logik der Philosophie und die Kategorienlehre")]), _vm._v(", which incorporates some of Husserl’s crucial conclusions on the problem of categorial apprehension and categorial intuition. [29] See also his "), _c('em', [_vm._v("Lehre vom Urteil")]), _vm._v(", 1912."), _c('a', {
    attrs: {
      "id": "rintfn30"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn30"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumbert"
  }, [_vm._v("8. Hans Driesch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentnumberx"
  }, [_vm._v("Also essentially influenced by phenomenology is Dreisch, in his so-called "), _c('em', [_vm._v("Ordnungslehre")]), _vm._v("."), _c('a', {
    attrs: {
      "id": "rintfn31"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn31"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("I will not go further into the effects of "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(" now. Instead, I will describe, albeit very briefly, the genesis of this work."), _c('a', {
    attrs: {
      "id": "rintfn32"
    }
  }), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intfn32"
    }
  }, [_vm._v("32")])]), _vm._v(" [30]")]), _vm._v(" "), _c('p', {
    staticClass: "footnotet"
  }, [_c('a', {
    attrs: {
      "id": "intfn1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn1"
    }
  }, [_vm._v("1")]), _vm._v(". [The Simon Moser "), _c('em', [_vm._v("Nachschrift")]), _vm._v(" or transcript (hereafter cited as “Moser,” followed by page and line) here corrects GA 21, p. 1.14–15. This is but one of the hundreds of disconnects between Moser’s record of Heidegger’s spoken words during the course and the text of GA 21.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn2"
    }
  }, [_vm._v("2")]), _vm._v(". [Moser (p. 2.30–3.5) records that Heidegger said at this point that human beings “are experienced insofar as they act, indeed act upon others and upon themselves.” Here, in "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0002-05.jpg"
    }
  }), _vm._v(" “human beings are understood as beings that, so to speak, take their ownmost being in hand.”]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn3"
    }
  }, [_vm._v("3")]), _vm._v(". Sextus Empiricus, "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-06.jpg"
    }
  }), _vm._v(" (Against the Mathematicians). The work deals with later skepticism, ca. 200 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("CE")]), _vm._v(". Still valuable on skepticism is Paul Natorp, "), _c('em', [_vm._v("Forschungen zur Geschichte des Erkenntnisproblems im Altertum. Protagoras, Demokrit, Epikur, und die Skepsis")]), _vm._v(" (Berlin: W. Hertz, 1884).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn4"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn4"
    }
  }, [_vm._v("4")]), _vm._v(". [Of the eight books of Sextus Empiricus’ "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-07.jpg"
    }
  }), _vm._v(" the last two, books 7 and 8, are sometimes treated as books 1 and 2 of Sextus’ "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0003-08.jpg"
    }
  }), _vm._v(" (Against the Logicians). This is the case in R. G. Bury’s bilingual edition, "), _c('em', [_vm._v("Sextus Empiricus")]), _vm._v(". The translation above, as elsewhere in this volume, follows Heidegger’s German translation of the Greek.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn5"
    }
  }, [_vm._v("5")]), _vm._v(". Xenocrates (396–314 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BCE")]), _vm._v(") was roughly a contemporary of Aristotle, and a follower of Speusippos, the first leader of the Academy after Plato. He catalogued and systematized Platonic philosophy in a scholastic way, taking studies that once were lived and putting them into the fixed form of a wisdom that could be taught.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn6"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn6"
    }
  }, [_vm._v("6")]), _vm._v(". Cf. Diogenes Laertius: "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-05.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-06.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0004-07.jpg"
    }
  }), _vm._v(" (III, 34). [“At first philosophical discourse was of one kind: the discussion of nature. In the second instance Socrates added the discussion of ethics, and thirdly Plato added dialectics, thereby completing (the contours of) philosophy.”]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn7"
    }
  }, [_vm._v("7")]), _vm._v(". [ "), _c('em', [_vm._v("GM")]), _vm._v(", p. 387 / tr. 1.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn8"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn8"
    }
  }, [_vm._v("8")]), _vm._v(". [Cicero uses "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-06.jpg"
    }
  }), _vm._v(" at "), _c('em', [_vm._v("De finibus bonorum et malorum")]), _vm._v(" I, 7, 22 (“iam in altera philosophiae parte quae est quaerendi ac disserendi, quae "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-06.jpg"
    }
  }), _vm._v(" dicitur”), and at "), _c('em', [_vm._v("De fato")]), _vm._v(" I, 1 (“Explicandaque vis est ratioque enuntiationum, quae Graeci "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-07.jpg"
    }
  }), _vm._v(" [i.e., ‘logical propositions’] vocant; totaque est "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-08.jpg"
    }
  }), _vm._v(" quam ‘rationem disserendi’ voco”). See Cicero, "), _c('em', [_vm._v("De Fato")]), _vm._v(", in "), _c('em', [_vm._v("De Oratore")]), _vm._v(", trans. H. Rackham (London: William Heinemann / Cambridge, Mass.: Harvard University Press, 1960), vol. 2, p. 192. Also see Carl Prantl, "), _c('em', [_vm._v("Geschichte der Logik im Abendlande")]), _vm._v(", 4 vols. (Leipzig, 1855–1870; reissued Leipzig: Gustav Fock, 1927 / Graz: Akademische Druck, 1955), vol. 1, pp. 535, 514 n. 27.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn9"
    }
  }, [_vm._v("9")]), _vm._v(". [Alexander of Aphrodisias, "), _c('em', [_vm._v("In Aristotelis Analyticorum Priorum Librum I Commentarium")]), _vm._v(", ed. Maximilian Wallies, "), _c('em', [_vm._v("Commentaria in Aristotelem Graeca")]), _vm._v(" (Berlin: Reimer, 1883), vol. 2, p. 1 (the opening sentence of his commentary): "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-09.jpg"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "block",
    attrs: {
      "alt": "Image",
      "src": "images/i0005-10.jpg"
    }
  }), _vm._v(" “Logic or syllogistics is the study that now lies before us.”]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn10"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn10"
    }
  }, [_vm._v("10")]), _vm._v(". Cf. Carl Prantl, "), _c('em', [_vm._v("Geschichte der Logik im Abendlande")]), _vm._v(", vol. 1, p. 533 n. 7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn11"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn11"
    }
  }, [_vm._v("11")]), _vm._v(". [From Moser (p. 11), fleshing out GA 21, p. 6.17.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn12"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn12"
    }
  }, [_vm._v("12")]), _vm._v(". [Here Heidegger ends his first lecture, Thursday, 5 November 1925.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn13"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn13"
    }
  }, [_vm._v("13")]), _vm._v(". [Here ends Heidegger’s lecture of 6 November 1925.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn14"
    }
  }, [_vm._v("14")]), _vm._v(". Not to be confused with the theory of science ["), _c('em', [_vm._v("Wissenschaftstheorie")]), _vm._v("].")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn15"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn15"
    }
  }, [_vm._v("15")]), _vm._v(". [Here Heidegger ends his lecture of 9 November 1925.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn16"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn16"
    }
  }, [_vm._v("16")]), _vm._v(". Aristotle’s principle of contradiction is also a relation of being and a law of being, something that has not been understood up to today.")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn17"
    }
  }, [_vm._v("17")]), _vm._v(". [Edmund Husserl, "), _c('em', [_vm._v("Logische Untersuchungen. Erster Theil: Prolegomena zur reinen Logik")]), _vm._v(" (Logical Investigations, Part One: Prolegomena to Pure Logic) and "), _c('em', [_vm._v("Zweiter Theil: Untersuchungen zur Phänomenologie und Theorie der Erkenntnis")]), _vm._v(" (Part Two: Investigations into the Phenomenology and Theory of Knowledge) (Halle: Max Niemeyer, 1900–1901). All citations from this work will follow the pagination of the first edition, which is the one Heidegger cites in this course. Texts of the first and second editions have been reissued as "), _c('em', [_vm._v("Husserliana")]), _vm._v(" (The Hague: Martinus Nijhoff), vol. XVIII, ed. Elmar Holenstein (1975), and vols. XIX/1 and XIX/2, ed. Ursula Panzer (1984). For an English edition see "), _c('em', [_vm._v("Logical Investigations")]), _vm._v(", trans. J. N. Findlay, 2 vols. (London: Routledge & Kegan Paul / New York: Humanities Press, 1970).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn18"
    }
  }, [_vm._v("18")]), _vm._v(". [This is only one of the many critiques of Husserl that Heidegger articulated during the Marburg years.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn19"
    }
  }, [_vm._v("19")]), _vm._v(". [Editor’s note: The plan of the lectures was changed as the course unfolded.] [Translator’s note: Nevertheless, in the present edition the table of contents and text follow Heidegger’s outline of the course as it is presented here, on the conviction that its part-headings adequately represent the trajectory of his exposition.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn20"
    }
  }, [_vm._v("20")]), _vm._v(". [Here is a first hint at what Heidegger will call "), _c('em', [_vm._v("Irre")]), _vm._v(" and the "), _c('em', [_vm._v("Un-wesen der Wahrheit")]), _vm._v(" in his “Vom Wesen der Wahrheit” (GA 9, esp. pp. 193–198); see also "), _c('em', [_vm._v("Pathmarks")]), _vm._v(", ed. William McNeill (Cambridge: Cambridge University Press, 1998), pp. 148–152. Heidegger’s students heard him say, not "), _c('em', [_vm._v("Wesen")]), _vm._v("—“essence”—but "), _c('em', [_vm._v("Weisen")]), _vm._v(", “ways” or “modes” of truth (Moser, p. 60.9; Weiss, p. 17.32).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn21"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn21"
    }
  }, [_vm._v("21")]), _vm._v(". [London: John W. Parker, 1843. Reissued in John Stuart Mill (1806–1873), "), _c('em', [_vm._v("Collected Writings")]), _vm._v(", 33 vols., ed. John M. Robson (Toronto: University of Toronto Press / London: Routledge & Kegan Paul, 1981–1991); here, vols. 7 and 8 respectively. Heidegger cites the work according to its German translation by Theodor Gomperz, "), _c('em', [_vm._v("System der deductiven und inductiven Logik. Eine Darlegung der Grundsätze der Beweislehre und der Methoden wissenschaftlicher Forschung")]), _vm._v(", in John Stuart Mill, "), _c('em', [_vm._v("Gesammelte Werke")]), _vm._v(", ed. Theodor Gomperz (Leipzig: Fues (R. Reisland), 1872–1873), vols. 2–4. However, in both GA 21 (p. 27.8) and in Moser (p. 61.21), a comma is incorrectly added after "), _c('em', [_vm._v("Grundsätze")]), _vm._v(", thereby changing the sense of the subtitle to: “the principles, the theory of evidence, and . . .” The Weiss transcript (p. 18.6) gets the title right.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn22"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn22"
    }
  }, [_vm._v("22")]), _vm._v(". [Christoph Sigwart (1830–1904), "), _c('em', [_vm._v("Logik")]), _vm._v(" (Tübingen: H. Laupp, 1873–1878; 5th edition, 1924, ed. Hans Meier). See also Christoph Sigwart, "), _c('em', [_vm._v("Logic")]), _vm._v(", 2nd rev. edition, 2 vols., trans. Helen Dendy (London: Swan Sonnenschein / New York: Macmillan, 1895); repr. in the series Phenomenology: Background, Foreground, and Influences (no. 12), 2 vols. (New York and London: Garland Publishing, 1980).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn23"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn23"
    }
  }, [_vm._v("23")]), _vm._v(". [Hermann Lotze (1817–1881), "), _c('em', [_vm._v("Logik. Drei Bücher vom Denken, vom Untersuchen und vom Erkennen: System der Philosophie")]), _vm._v(" (Leipzig: S. Hirzel, 1874; 2nd edition, 1880), vol. 1. See also Hermann Lotze, "), _c('em', [_vm._v("System of Philosophy, Part I. Logic, in Three Books: Of Thought, Of Investigation, and Of Knowledge")]), _vm._v(", 2 vols., ed. and trans. Bernard Bosanquet (Oxford: Clarendon Press, 1884). The second edition (1888) was reissued in the series Phenomenology: Background, Foreground, and Influences (no. 8), 2 vols. (New York and London: Garland Publishing, 1980).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn24"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn24"
    }
  }, [_vm._v("24")]), _vm._v(". [Heidegger is referring to Lotze’s "), _c('em', [_vm._v("Logic")]), _vm._v(" (Leipzig: Weidemann, 1843).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn25"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn25"
    }
  }, [_vm._v("25")]), _vm._v(". [Published in 1912, ed. Georg Misch, as a new printing of the second edition of 1880.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn26"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn26"
    }
  }, [_vm._v("26")]), _vm._v(". [Wilhelm Schuppe (1839–1913), "), _c('em', [_vm._v("Erkenntnistheoretische Logik")]), _vm._v(" (Bonn: E. Weber, 1878).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn27"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn27"
    }
  }, [_vm._v("27")]), _vm._v(". [Alexander Pfänder (1871–1941), "), _c('em', [_vm._v("Logik")]), _vm._v(", in Husserl’s "), _c('em', [_vm._v("Jahrbuch für Philosophie und phänomenologische Forschung")]), _vm._v(", vol. 9 (Halle: Max Niemeyer, 1921; 2nd rev. edition, 1929).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn28"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn28"
    }
  }, [_vm._v("28")]), _vm._v(". [The actual date of publication is 1921. See Edmund Husserl, "), _c('em', [_vm._v("Aufsätze und Vorträge (1911–1921)")]), _vm._v(", ed. Thomas Nenon and Hans Rainer Sepp = "), _c('em', [_vm._v("Husserliana")]), _vm._v(" XXV (Dordrecht and Boston: Martinus Nijhoff / Kluwer, 1987), p. 67.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn29"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn29"
    }
  }, [_vm._v("29")]), _vm._v(". [Here Heidegger ends his lecture of 10 November 1925.]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn30"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn30"
    }
  }, [_vm._v("30")]), _vm._v(". [Both books were reprinted by the original publisher in Emil Lask, "), _c('em', [_vm._v("Gesammelte Schriften")]), _vm._v(", ed. Eugen Herrigel (Tübingen: J. C. B. Mohr (Paul Siebeck), 1923).")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn31"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn31"
    }
  }, [_vm._v("31")]), _vm._v(". [Hans Driesch (1867–1941), "), _c('em', [_vm._v("Ordnungslehre. Ein System des nicht-metaphysichen Teiles der Philosophie. Mit besonderer Berücksichtigung der Lehre vom Werden")]), _vm._v(" (Jena: Diederichs, 1912; 2nd edition, 1923).]")]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "intfn32"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/introduction#rintfn32"
    }
  }, [_vm._v("32")]), _vm._v(". [GA 21, p. 30, is blank.]")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b3e8c9b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/introduction.vue
// module id = 78
// module chunks = 0